/** Visually hidden but accessible to screen readers. */
export const visuallyHiddenStyle = {
    position: "absolute",
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: 0
};
//# sourceMappingURL=visuallyHiddenStyle.js.map